import { createReducer, on } from "@ngrx/store";
import * as Auctions from "./auction.actions";

export type PermissionCard = "restricted" | "notTermsOfuse" | "standard";

export type StateAuctionType = {
  acceptTermsOfuse?: boolean; // Termo é referente ao leilao
  edict?: string; // url do termo do leilao
  auctionKey?: string; // id leilao
  canBid?: boolean; // Permissao nivel de usuário
  isLiveTrading?: boolean; // A nivel de leilao e avisa que o timer dos lotes esta terminando _ 2min por lote.
  permissionCard?: PermissionCard;
};

export const initialState: StateAuctionType = {
  acceptTermsOfuse: false,
  edict: "",
  auctionKey: "",
  canBid: true,
  isLiveTrading: false,
  permissionCard: "standard",
};

export const reducers = createReducer(
  initialState,
  on(Auctions.saveAcceptTermsOfuse, (state, action) => ({
    ...state,
    acceptTermsOfuse: action.acceptTermsOfuse,
  })),

  on(Auctions.saveCanBid, (state, action) => {
    console.log("%csaveCanBid", "background-color: cyan; color: black");
    return {
      ...state,
      canBid: action.canBid,
    };
  }),

  on(Auctions.saveAllState, (state, action) => ({
    ...action,
  }))
);

// export const counterReducer = createReducer(
//   initialState,
//   on(increment, (state) => state + 1),
//   on(decrement, (state) => state - 1),
//   on(reset, (state) => 0)
// );
